<template>
  <v-app v-if="loggedIn" :class="{ 'cursor-none': mouseHidden }" @mousemove="mouseMove">

    <v-main class="d-flex flex-column align-center justify-center" style="min-height: 300px">

      <ToastAlert v-if="Object.keys(alerts.currentAlert).length" :type="alerts.currentAlert.type"
        :title="alerts.currentAlert.title" :text="alerts.currentAlert.text" :code="alerts.currentAlert.code" />

      <router-view />

      <MainSpeedDial :shown="mainSpeedDialShown" />
    </v-main>
  </v-app>
</template>

<script>
//Auth0
import { useAuth0 } from '@auth0/auth0-vue';

import ToastAlert from '@/components/feedback/ToastAlert';
import MainSpeedDial from './components/speed-dials/MainSpeedDial.vue';

export default {
  name: 'App',
  data() {
    return {
      loggedIn: useAuth0().isAuthenticated,
      alerts: {
        currentAlert: {},
        state: false,
        history: {},
      },
      mouseMoveTimer: null,
      mouseHidden: true,
      mainSpeedDialShown: false,
    }
  },
  components: {
    ToastAlert,
    MainSpeedDial,
  },
  methods: {
    newAlert(type = 'info', title = 'Unknown', text, code) {
      this.alerts.currentAlert = {};

      this.$nextTick(() => {

        this.alerts.currentAlert = {
          id: Date.now(),
          type: type,
          title: title,
          text: text,
          code: code,
        };
      });
    },
    mouseMove() {

      clearTimeout(this.mouseMoveTimer);

      this.mouseMoveTimer = setTimeout(() => {
        this.mouseHidden = true;
        this.mainSpeedDialShown = false;
      }, 4000);

      this.mouseHidden = false;
      this.mainSpeedDialShown = true;
    },
  },
  provide() {
    return {
      newAlert: this.newAlert,
    };
  },
}
</script>
